var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"truncate-list"},[_vm._l((_vm.displayedItems),function(item,index){return _c('vs-list-item',{key:item.id,attrs:{"subtitle":item.nomeGrupo}})}),_vm._v("\n  ...\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }